import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol } from "../../../components/common/UiPageElements";
import { UiCol, UiSingleRow } from "../../../components/grid-container/GridContainer";

export const KnowledgeMonthlyPoints = () => {
    return (
        <>
            <UiContentCol>
                <UiCardTitle title="Monthly Points" />
                <UiSingleRow className="sb-knw-monthly-points">
                    <UiCol md="4">
                        <div className="sb-knw-monthly-points__sb-point-card">
                            <div>
                                <h4>25k</h4>
                                <p>January</p>
                            </div>
                        </div>
                    </UiCol>

                    <UiCol md="4">
                        <div className="sb-knw-monthly-points__sb-point-card">
                            <div>
                                <h4>55.6k</h4>
                                <p>Feburary</p>
                            </div>
                        </div>
                    </UiCol>


                    <UiCol md="4">
                        <div className="sb-knw-monthly-points__sb-point-card">
                            <div>
                                <h4>105.6k</h4>
                                <p>April</p>
                            </div>
                        </div>
                    </UiCol>
                </UiSingleRow>


               <h3 className="sb-knw-monthly-points__title">Lorem Epsum</h3>
                <p className="sb-knw-monthly-points__sub-para">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>

                <p className="sb-knw-monthly-points__para">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu. <br /> <br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu.<br /> <br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu.<br /> <br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu.<br /> <br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu.<br /> <br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu.<br /> <br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu.<br /> <br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed
                </p>

            </UiContentCol>
        </>
    )
}